module.exports = __webpack_public_path__ + "img/print-logo.676cc81a.png";